import { COLLECTIONS } from "constants/action-types";
import { TotalTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { MetricsKind } from "helpers/metrics/types";

export const mutateReviewPlans = (
    collectionId: string,
    dimensionPath: string[],
    totalType: TotalTypes,
    value: string | number
) => ({
    payload: {
        collectionId,
        dimensionPath,
        totalType,
        value,
    },
    type: COLLECTIONS.COLLECTION.REVIEW_PLANS.MUTATE,
});

export const mutateMetricReviewPlans = (
    collectionId: string,
    dimensionPath: string[],
    metricKind: MetricsKind,
    value: string | number
) => ({
    payload: {
        collectionId,
        dimensionPath,
        metricKind,
        value,
    },
    type: COLLECTIONS.COLLECTION.REVIEW_PLANS.MUTATE,
});
